import { Navigate, useSearchParams } from '@/util/react-router-dom';

// This page is for legacy purposes. The old application used to redirect to this page when the user was logged in.
// It is used to redirect to the root page with the search params.
export function ConvergeRedirect() {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const to = search ? `/?${search}` : '/';

  return <Navigate to={to} replace doNotResolveBrandingPath />;
}
